import { InjectionToken } from '@angular/core';

/**
 * Interface for providing the authenticated user ID to the auth interceptor.
 */
export interface AuthUserProvider {
  getUserId(): string | null;
  getUserRoles?(): string[] | null;
  getSubjectType?(): string | null;
}

/**
 * Injection token for the auth user provider.
 * Shell apps should provide this with their auth service implementation.
 */
export const AUTH_USER_PROVIDER = new InjectionToken<AuthUserProvider>(
  'AUTH_USER_PROVIDER',
);
